import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import { grey, green, red } from "@material-ui/core/colors";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import moment from "moment";

import Rating from "@material-ui/lab/Rating";
import { Tooltip, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    tableContainer: {
        borderRadius: theme.shape.borderRadius * 3,
        boxShadow: "0 4px 20px 0 rgba(0,0,0,0.05)",
        border: `1px solid ${theme.palette.divider}`,
        overflow: "hidden",
    },
    headerCell: {
        backgroundColor: theme.palette.background.default,
        fontWeight: 700,
        textTransform: "uppercase",
        fontSize: "0.75rem",
        letterSpacing: "1px",
        color: theme.palette.text.secondary,
        borderBottom: `2px solid ${theme.palette.divider}`,
    },
    row: {
        transition: "background-color 0.2s",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.02)",
        },
    },
    badge: {
        padding: "6px 12px",
        borderRadius: "20px",
        fontSize: "0.75rem",
        fontWeight: 700,
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
    },
    onlineBadge: {
        backgroundColor: "rgba(67, 233, 123, 0.15)",
        color: "#2ecc71",
    },
    offlineBadge: {
        backgroundColor: "rgba(231, 76, 60, 0.15)",
        color: "#e74c3c",
    },
    statusDot: {
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "currentColor",
    },
}));

export function RatingBox({ rating }) {
    const ratingTrunc = rating && rating > 0 ? rating.toFixed(1) : 0;
    return (
        <Tooltip title={ratingTrunc} arrow>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Rating defaultValue={ratingTrunc} max={5} precision={0.1} readOnly size="small" />
                <Typography variant="caption" style={{ marginLeft: 8, fontWeight: 700, color: grey[600] }}>
                    {ratingTrunc}
                </Typography>
            </div>
        </Tooltip>
    );
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props;
    const classes = useStyles();

    function renderList() {
        return attendants.map((a, k) => (
            <TableRow key={k} className={classes.row}>
                <TableCell style={{ fontWeight: 600 }}>{a.name}</TableCell>
                <TableCell align="center">
                    <RatingBox rating={a.rating} />
                </TableCell>
                <TableCell align="center" style={{ fontWeight: 500, color: grey[700] }}>
                    {formatTime(a.avgSupportTime, 2)}
                </TableCell>
                <TableCell align="center">
                    <div className={`${classes.badge} ${a.online ? classes.onlineBadge : classes.offlineBadge}`}>
                        <span className={classes.statusDot} />
                        {a.online ? "Online" : "Offline"}
                    </div>
                </TableCell>
            </TableRow>
        ));
    }

    function formatTime(minutes) {
        return moment().startOf("day").add(minutes, "minutes").format("HH[h] mm[m]");
    }

    return !loading ? (
        <TableContainer component={Paper} className={classes.tableContainer}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headerCell}>Nome</TableCell>
                        <TableCell align="center" className={classes.headerCell}>Avaliações</TableCell>
                        <TableCell align="center" className={classes.headerCell}>T.M. de Atendimento</TableCell>
                        <TableCell align="center" className={classes.headerCell}>Status (Atual)</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {renderList()}
                    {/* <TableRow>
                        <TableCell>Nome 4</TableCell>
                        <TableCell align="center">10</TableCell>
                        <TableCell align="center">10 minutos</TableCell>
                        <TableCell align="center">
                            <CheckCircleIcon className={classes.off} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Nome 5</TableCell>
                        <TableCell align="center">10</TableCell>
                        <TableCell align="center">10 minutos</TableCell>
                        <TableCell align="center">
                            <CheckCircleIcon className={classes.on} />
                        </TableCell>
                    </TableRow> */}
                </TableBody>
            </Table>
        </TableContainer>
    ) : (
        <Skeleton variant="rect" height={150} />
    );
}